import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { Colors } from '@root/core/src/utils/styles';

export default function RootLegalIcon({
  strokeColor = Colors.rootOrange(),
  size = 60,
}) {
  return (
    <svg
      fill={'none'}
      height={size + 1}
      viewBox={`0 0 ${size} ${size + 1}`}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <mask
        fill={'white'}
        id={'root-legal-icon-path'}
      >
        <path
          clipRule={'evenodd'}
          d={'M60.0008 0.109375H30.0004V0.109923H0V30.1099V30.1103V60.1103H30.0004V30.1103V30.1099V30.1098H60.0008V0.109375Z'}
          fillRule={'evenodd'}
        />
      </mask>
      <path
        d={'M30.0004 0.109375V-0.890625H29.0004V0.109375H30.0004ZM60.0008 0.109375H61.0008V-0.890625H60.0008V0.109375ZM30.0004 0.109923V1.10992H31.0004V0.109923H30.0004ZM0 0.109923V-0.890077H-1V0.109923H0ZM0 60.1103H-1V61.1103H0V60.1103ZM30.0004 60.1103V61.1103H31.0004V60.1103H30.0004ZM30.0004 30.1098V29.1098H29.0004V30.1098H30.0004ZM60.0008 30.1098V31.1098H61.0008V30.1098H60.0008ZM30.0004 1.10938H60.0008V-0.890625H30.0004V1.10938ZM31.0004 0.109923V0.109375H29.0004V0.109923H31.0004ZM30.0004 -0.890077H0V1.10992H30.0004V-0.890077ZM-1 0.109923V30.1099H1V0.109923H-1ZM-1 30.1099V30.1103H1V30.1099H-1ZM-1 30.1103V60.1103H1V30.1103H-1ZM0 61.1103H30.0004V59.1103H0V61.1103ZM31.0004 60.1103V30.1103H29.0004V60.1103H31.0004ZM31.0004 30.1103V30.1099H29.0004V30.1103H31.0004ZM31.0004 30.1099V30.1098H29.0004V30.1099H31.0004ZM60.0008 29.1098H30.0004V31.1098H60.0008V29.1098ZM59.0008 0.109375V30.1098H61.0008V0.109375H59.0008Z'}
        fill={strokeColor}
        mask={'url(#root-legal-icon-path)'}
      />
      <line
        stroke={strokeColor}
        x1={'29.3957'}
        x2={'0.914255'}
        y1={'29.4494'}
        y2={'0.841455'}
      />
    </svg>
  );
}

RootLegalIcon.propTypes = {
  size: PropTypes.number,
  strokeColor: PropTypes.string,
};
